<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-tv"></i> Inventaris Barang
                </div>
                <div class="card-tools mr-0">
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                    <button v-if="$can('create inventaris barang')" type="button" class="btn btn-primary" @click="addNew">
                        <i class="fas fa-plus-square"></i> Inventaris Barang
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/inventaris-barangs"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="action" slot-scope="props">
                            <button type="button" title="View" @click="view(props.rowData)" class="btn btn-link px-1"><i class="fas fa-eye"></i></button>
                            <button v-if="$can('edit inventaris barang') && isAllowAction(props.rowData)" type="button" title="Edit" @click="edit(props.rowData)" class="btn btn-link px-1"><i class="fas fa-edit"></i></button>
                            <button v-if="$can('approve inventaris barang') && isAllowApprove(props.rowData)" type="button" title="Approve" @click="approve(props.rowData)" class="btn btn-link px-1"><i class="fas fa-check-double"></i></button>
                            <button v-if="$can('delete inventaris barang') && isAllowAction(props.rowData)" type="button" title="Hapus" @click="deleteInventaris(props.rowData)" class="btn btn-link px-1 text-danger"><i class="fas fa-trash-alt"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="editModal" size="md" :hide-header="true" :hide-footer="true">
            <edit-form :isEdit="isEdit" :value="currentInventarisBarang" @saved="saved" @cancel="editModal = false"></edit-form>
		</b-modal>

        <b-modal v-model="viewModal" size="md" :hide-header="true" :hide-footer="true">
            <viewer :value="currentInventarisBarang" @cancel="viewModal = false"></viewer>
		</b-modal>

        <b-modal v-model="showApproval" size="md" :hide-header="true" :hide-footer="true">
            <viewer is-approval :value="currentInventarisBarang" @saved="saved" @cancel="showApproval = false"></viewer>
		</b-modal>

        <b-modal v-model="showDeleteModal" title="Hapus Buku" size="sm" @ok="_deleteInventaris" @cancel="showDeleteModal = false">
            <div class="row m-0 mt-2">
                <div class="col">
                    <div class="form-group">
                        <label class="form-control-label">Status</label>
                        <multiselect class="form-input" v-validate="'required'" name="status" v-model="status" :options="statusOptions" :placeholder="'Pilih status'" :searchable="true"
                            label="value" track-by="name" :show-labels="false" :allowEmpty="false"></multiselect>
                        <span class="text-danger">{{ errors.first('status') }}</span>
                    </div>
                    <div class="form-group" v-if="status && status.name == 'terjual'">
                        <label class="form-control-label">Harga Terjual</label>
                        <input v-validate="'required|min_value:0'" min="0" v-model="harga_keluar" type="number" name="harga_keluar" class="form-control">
                        <span class="text-danger">{{ errors.first('harga_keluar') }}</span>
                    </div>
                </div>
            </div>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import EditForm from './Form';
import SearchBar from './SearchBar';
import ExportMixin from '../../mixin/export';
import Viewer from './Viewer';
import Multiselect from 'vue-multiselect';

export default {
    name: "inventaris-barang",

    components: {
        EditForm,
        SearchBar,
        Viewer,
        Multiselect,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentInventarisBarang: null,
            searchText: '',
            searchDate: '',
            searchStatus: '',
            searchKesediaan: 'tersedia',
            editModal: false,
            viewModal: false,
            isPreview: false,
            isEdit: false,
            showApproval: false,
            noBatal: false,
            showDeleteModal: false,
            status: {
                name: 'terjual',
                value: 'Terjual',
            },
            harga_keluar: null,
            statusOptions: [
                {
                    name: 'terjual',
                    value: 'Terjual',
                },
                {
                    name: 'hilang',
                    value: 'Hilang',
                },
                {
                    name: 'rusak',
                    value: 'Rusak',
                },
            ],
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'name',
                    title: 'Nama Barang',
                    sortField: 'name',
                },
                {
                    name: 'tanggal_pembelian',
                    title: 'Tanggal Pembelian',
                    sortField: 'tanggal_pembelian',
                    callback: 'formatDate',
                },
                {
                    name: 'jumlah',
                    title: 'Jumlah',
                    sortField: 'jumlah',
                    callback: 'formatNumber',
                },
                {
                    name: 'harga',
                    title: 'Harga',
                    sortField: 'harga',
                    callback: 'formatNumber',
                },
                {
                    name: 'total',
                    title: 'Total',
                    sortField: 'total',
                    callback: 'formatNumber',
                },
                {
                    name: 'status',
                    title: 'Status',
                    sortField: 'status',
                    callback: 'camelCase',
                },
                {
                    name: 'keterangan',
                    title: 'Keterangan',
                },
                {
                    name: '__slot:action',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "updated_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                status: this.searchStatus,
                kesediaan: this.searchKesediaan,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchStatus = search.searchStatus;
            this.searchKesediaan = search.searchKesediaan;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchStatus = '';
            this.searchKesediaan = 'tersedia';
            this.refresh();
        },

        addNew() {
            this.isEdit = false;
            this.currentInventarisBarang = null;
            this.editModal = true;
        },

        edit(rowData) {
            this.isEdit = true;
            this.currentInventarisBarang = Object.assign({}, rowData);
            this.editModal = true;
        },

        view(rowData) {
            this.currentInventarisBarang = Object.assign({}, rowData);
            this.viewModal = true;
        },

        saved() {
            this.editModal = false;
            this.isEdit = false;
            this.showApproval = false;
            this.refresh();
        },

        isAllowApprove(data) {
            return (data.deleted_at && !data.approved_at) || data.inventaris_barang_update;
        },

        isAllowAction(data) {
            return !data.deleted_at && !data.inventaris_barang_update;
        },

        approve(inventarisBarang) {
            this.currentInventarisBarang = Object.assign({}, inventarisBarang);
            this.showApproval = true;
        },

        printList() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/inventaris-barangs/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        deleteInventaris(rowData) {
            this.currentInventarisBarang = Object.assign({}, rowData);
            this.showDeleteModal = true;
        },

        _deleteInventaris() {
            let self = this;

            Swal.fire({
                title: 'Apakah anda yakin?',
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, hapus!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.isLoading = true;
                    self.$Progress.start();
                    axios({
                        method: 'delete',
                        url: '/api/inventaris-barangs/' + self.currentInventarisBarang.id,
                        data: {
                            status: self.status && self.status.name ? self.status.name : null,
                            harga_keluar: self.harga_keluar,
                        },
                    })
                    .then(function (response) {
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        self.isLoading = false;
                        self.$Progress.finish();
                        self.refresh();
                    })
                    .catch(function (error) {
                        self.responseFailed(error);
                    });
                }
            })
        },
    },
}
</script>
